import { refreshDrugCache } from "../services/refresh-drug-cache";
import { usePrescriptionMutation } from "./use-prescription-mutation";

export function useRefreshDrugCache() {
  return usePrescriptionMutation({
    mutationFn: refreshDrugCache,
    successMessage: (data) =>
      data.message || "Drug database cache refreshed successfully",
    errorMessage: "Failed to refresh drug database cache",
    invalidateQueries: false, // Don't invalidate prescriptions query for cache refresh
  });
}
